/* Edit Order → "Add products to this parcel" rows (same tracking / customer / invoice). */
import { Plus, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";

export const AddProductsSection = ({ items, setItems, parcelSize, locked }) => {
  if (locked) {
    return (
      <div className="mt-3 rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-xs text-slate-500" data-testid="or-add-products-locked">
        Products can't be added — {locked}.
      </div>
    );
  }
  const set = (i, k, v) => setItems(items.map((it, j) => (j === i ? { ...it, [k]: v } : it)));
  return (
    <div className="mt-3 rounded-lg border border-indigo-200 bg-indigo-50/40 p-3" data-testid="or-add-products">
      <div className="flex items-center gap-2 mb-2">
        <span className="text-xs font-bold text-indigo-800">Add products to this parcel</span>
        <span className="text-[11px] text-slate-500">({parcelSize} product{parcelSize === 1 ? "" : "s"} now · same tracking, customer & invoice · login password + reason on Save)</span>
        <button type="button" onClick={() => setItems([...items, { medicine: "", quantity: "", second_name: "" }])}
          className="ml-auto inline-flex items-center gap-1 rounded-md bg-indigo-600 hover:bg-indigo-700 px-2 py-1 text-[11px] font-semibold text-white transition-colors"
          data-testid="or-add-product-btn">
          <Plus className="w-3 h-3" /> Add product
        </button>
      </div>
      {items.map((it, i) => (
        <div key={i} className="grid grid-cols-[1fr_90px_1fr_28px] gap-2 mb-1.5">
          <Input value={it.medicine} onChange={(e) => set(i, "medicine", e.target.value)} placeholder="Product / medicine"
            className="h-8 text-xs" data-testid={`or-add-product-medicine-${i}`} />
          <Input value={it.quantity} onChange={(e) => set(i, "quantity", e.target.value)} placeholder="Qty"
            className="h-8 text-xs" data-testid={`or-add-product-qty-${i}`} />
          <Input value={it.second_name} onChange={(e) => set(i, "second_name", e.target.value)} placeholder="Second name (optional)"
            className="h-8 text-xs" data-testid={`or-add-product-second-${i}`} />
          <button type="button" onClick={() => setItems(items.filter((_, j) => j !== i))} title="Remove"
            className="h-8 w-7 inline-flex items-center justify-center rounded-md text-rose-600 hover:bg-rose-50"
            data-testid={`or-add-product-remove-${i}`}>
            <Trash2 className="w-3.5 h-3.5" />
          </button>
        </div>
      ))}
    </div>
  );
};
